import { onSnapshot } from "firebase/firestore";
import { parseSnapshotMetadata } from "./firestoreSnapshotMetadata";

/**
 * onSnapshot wrapper that always includes metadata change events and passes
 * parsed freshness alongside the raw snapshot.
 *
 * @param {import('firebase/firestore').Query|import('firebase/firestore').DocumentReference} queryOrDoc
 * @param {(snapshot: import('firebase/firestore').DocumentSnapshot|import('firebase/firestore').QuerySnapshot, freshness: ReturnType<typeof parseSnapshotMetadata>) => void} callback
 * @param {(error: Error) => void} [onError]
 */
export const onSnapshotWithMetadata = (queryOrDoc, callback, onError) =>
  onSnapshot(
    queryOrDoc,
    { includeMetadataChanges: true },
    (snapshot) => {
      callback(snapshot, parseSnapshotMetadata(snapshot));
    },
    onError
  );
